module.exports = __webpack_public_path__ + "img/arrowFull_left_b.d68db319.svg";